<template>
    <div class="guide">
        <ui-popup ref="hello" hide-close :close-on-esc="false" :click-outside-to-close="false">
            <div class="guide-hello">
                <div class="guide-hello__text">Ваша задача — захватить мировой рынок через <a :href="$store.state.links.ebay" target="_blank">eBay</a>. Как вы это будете делать, решать вам. Но вот что вам стоит знать перед началом.</div>
                <div class="guide-hello__actions">
                    <button class="ui-btn" @click="startGuide">Продолжить</button>
                    <button class="btn" @click="onSkip">Пропустить обучение</button>
                </div>
            </div>
        </ui-popup>

        <transition name="fade2">
            <div class="guide__body" v-if="step && started" :class="{[`guide__body--index-${stepIndex}`]: true}">
                <div class="guide__content">
                    <div class="guide__title" v-if="step.title">{{ step.title }}</div>
                    <div class="guide__description" v-html="step.description"></div>
                </div>

                <div class="guide__footer">
                    <div class="guide__actions">
                        <template v-if="steps.length - 1 === stepIndex">
                            <a class="ui-btn theme-light border bold guide__btn-start" @click="startGame">Начать игру</a>
                        </template>
                        <template v-else>
                            <button class="ui-btn" @click="next">Продолжить</button>
                            <button class="btn" @click="onSkip">
                                Пропустить обучение
                            </button>
                        </template>
                    </div>

                    <div class="guide__dots" v-if="steps.length - 1 !== stepIndex">
                        <span
                            v-for="(item, index) in steps.slice(0, -1)"
                            :key="index"
                            :class="{active: stepIndex === index}"
                        >
                        </span>
                    </div>
                </div>

                <div class="guide__arrows">
                    <div>
                        <img class="guide-img-desktop" v-if="stepIndex === 0" src="@/assets/images/guide/1.png" />
                        <img class="guide-img-desktop" v-if="stepIndex === 1" src="@/assets/images/guide/2.svg" />
                        <img class="guide-img-desktop" v-if="stepIndex === 2" src="@/assets/images/guide/3.png" />
                        <img class="guide-img-desktop" v-if="stepIndex === 3" src="@/assets/images/guide/4.png" />
                        <img class="guide-img-desktop" v-if="stepIndex === 4" src="@/assets/images/guide/5.png" />
                        <template v-if="stepIndex === 5">
                            <img class="guide-img-desktop" src="@/assets/images/guide/6.1.png" />
                            <img class="guide-img-desktop" src="@/assets/images/guide/6.2.png" />
                            <img class="guide-img-desktop" src="@/assets/images/guide/6.3.png" />
                        </template>
                    </div>

                    <div>
                        <img class="guide-img-mobile" v-if="stepIndex === 0" src="@/assets/images/guide/1.m.png" />
                        <img class="guide-img-mobile" v-if="stepIndex === 1" src="@/assets/images/guide/2.m.png" />
                        <img class="guide-img-mobile" v-if="stepIndex === 2" src="@/assets/images/guide/3.m.png" />
                        <img class="guide-img-mobile" v-if="stepIndex === 3" src="@/assets/images/guide/4.m.png" />
                        <img class="guide-img-mobile" v-if="stepIndex === 4" src="@/assets/images/guide/5.m.png" />
                        <template v-if="stepIndex === 5">
                            <img class="guide-img-mobile" src="@/assets/images/guide/6.1.m.png" />
                            <img class="guide-img-mobile" src="@/assets/images/guide/6.2.m.png" />
                            <img class="guide-img-mobile" src="@/assets/images/guide/6.3.m.png" />
                        </template>
                    </div>
                </div>
            </div>
        </transition>

        <transition name="fade" key="guide">
            <ui-overlay
                v-if="step && started"
                class="guide__overlay"
                :rects="rectsData"
                :opacity="0.9"
            />
        </transition>
    </div>
</template>

<script>
    import analytics from '@/utils/analytics.js'
    import { mapActions, mapState, mapGetters } from 'vuex'

    export default {
        data () {
            return {
                update: Date.now(),
                started: false,
                rects: []
            }
        },

        computed: {
            ...mapState('guide', ['step', 'steps']),
            ...mapGetters('guide', ['stepIndex']),

            rectsData () {
                const wrap = document.querySelector('.game')
                const wrapRect = wrap.getBoundingClientRect()

                return this.rects.map(item => {
                    const elementRect = document.querySelector(item.element).getBoundingClientRect()
                    // const scrollTop = document.scrollingElement.scrollTop
                    const data = {}
                    const padding = item.padding || [0, 0, 0, 0]

                    data.update = this.update
                    data.key = item.key
                    data.rx = item.radius
                    data.ry = item.radius
                    data.top = item.top || elementRect.top - padding[0] - wrapRect.top
                    data.left = elementRect.left - padding[3] - wrapRect.left
                    data.width = elementRect.width + padding[1] + padding[3]
                    data.height = item.height || elementRect.height + padding[0] + padding[2]

                    return data
                })
            }
        },

        methods: {
            ...mapActions('control', ['start', 'stop', 'pause']),
            ...mapActions('guide', ['next']),

            startGame () {
                this.skipGuide()
            },

            onSkip () {
                analytics.getPixel('https://ads.adfox.ru/260477/getCode?p1=ccqdp&p2=frfe&pfc=cvroc&pfb=hujgt&pr=%random%&ptrc=b')
                this.skipGuide()
            },

            skipGuide () {
                this.stop()
                this.$refs.hello.close()
                this.started = false
                sessionStorage.setItem('is-not-first-time', '1')
                window.removeEventListener('resize', this.onUpdate)
                document.body.style['min-height'] = null
                if (this.$route.name !== 'game-goods') {
                    this.$router.push({name: 'game-goods'})
                }
            },

            startGuide () {
                this.$refs.hello.close()
                setTimeout(() => {
                    this.next()
                    this.started = true
                }, 400)

                this.onUpdate()
                window.addEventListener('resize', this.onUpdate)
            },

            changeStep (step) {
                if (step.route && (this.$route.name !== step.route.name)) {
                    this.$router.push(step.route)
                }
                const config = this.getConfig(step)
                setTimeout(() => {
                    this.rects = config.rects || []
                }, step.timeout || 0)
            },

            getConfig (step) {
                const mediaKeys = Object.keys(step.media).sort()
                const width = window.innerWidth
                let config;
                for (let i = 0; i < mediaKeys.length; i++) {
                    const key = mediaKeys[i]
                    if (!config || width > key) config = step.media[key]
                }
                return config
            },

            onUpdate () {
                this.update = Date.now()
                if (window.innerHeight < 650) {
                    document.body.style['min-height'] = '650px'
                }
            }
        },

        watch: {
            $route (route) {
                const notFirstTime = sessionStorage.getItem('is-not-first-time')
                if (route.name === 'game-goods' && !notFirstTime) {
                    this.$refs.hello.open()
                }
            },
            step (step) {
                if (this.started) {
                    this.changeStep(step)
                }
            }
        }
    }
</script>

<style lang="stylus" scoped>
    $dur = 0.6s ease
    .guide {
        &__body {
            position absolute
            top 10%
            color #fff
            z-index 2000
            font-size 1.8rem
            line-height 2.5rem
            transition top $dur, left $dur, opacity $dur

            +layout-sm() {
                font-size 1.5rem
                line-height 2.1rem
            }
        }

        &__description {
            & >>> a {
                color #ffffff
                font-weight $font-bold
            }
        }

        &__title {
            font-weight $font-bold
        }

        &__actions {
            margin-top 2rem
            display flex
            align-items center
            .ui-btn {
                width 18.8rem
                margin-right 1.7rem
                font-size 1.5rem
                color #121258
                background-color #C5E5FB
                flex-shrink 0
                +layout-xs() {
                    width 17.5rem
                    height 4.8rem
                    min-height 4.8rem
                }
            }
            .btn {
                cursor pointer
                border-radius 0
                border 0 none
                font-size 1.5rem
                line-height 1.8rem
                color #93C9FF
                text-align left
                background-color transparent
                width 9rem
                padding 0
            }
        }

        &__btn-start {
            width 26.5rem!important
            height 7.8rem!important
            font-size 2rem!important
            color #2B0EAF!important
            background-color #fff!important
            +layout-sm() {}
        }

        &__dots {
            display flex
            align-items center
            margin-left -0.4rem
            margin-top 1.8rem

            span {
                width 0.8rem
                height @width
                border-radius 50%
                background-color #3665F4
                transition background-color 0.3s ease
                margin 0 0.4rem
                &.active {
                    background-color #C5E5FB
                }
            }
        }

        &__overlay {
            position absolute
        }
    }

    .guide-hello {
        width 34rem
        +layout-xs() {
            width 23.4rem
        }
        &__text {
            font-size 1.8rem
            line-height 2.5rem

            a {
                color #382AEF
                font-weight $font-bold
            }
        }
        &__actions {
            margin-top 2rem
            display flex
            align-items center
            +layout-xs() {
                display block
                margin-top 1.2rem
            }

            .ui-btn {
                width 18.8rem
                margin-right 1.7rem
                background-color #121258
                color $color-accent
                font-size 1.5rem
                flex-shrink 0
                +layout-xs() {
                    margin-right 0
                    width 100%
                    font-size 2rem
                }
            }
            .btn {
                cursor pointer
                border-radius 0
                border 0 none
                font-size 1.5rem
                line-height 1.8rem
                color #382AEF
                text-align left
                background-color transparent
                width 9rem
                padding 0
                +layout-xs() {
                    width 100%
                    margin-top 1.5rem
                    text-align center
                }
            }
        }
    }


    .guide__body {
        &--index-0 {
            top 3rem
            left 50%
            width 45%

            .guide__arrows {
                position absolute
                right 100%
                top 8%
                margin-right 2rem
                img {
                    width 83px
                    height auto
                }
            }

            +layout-md() {
                left 45%
                width 50%
            }
            +layout-sm() {
                width 23rem
                left 6rem
                top 10rem
                .guide__footer {
                    position absolute
                    top 36rem
                }
                .guide__arrows {
                    left 5rem
                    top 100%
                    margin-top 1rem
                    margin-right 0
                    img {
                        width auto
                        height 50px
                    }
                }
            }
            +layout-xs() {
                left 2rem
                top 4.8rem
                .guide__footer {
                    position absolute
                    top 36rem
                }
            }
        }
        &--index-1 {
            top 18rem
            left calc(50% + 105px)
            width 33rem
            .guide__arrows {
                position absolute
                bottom 100%
                right 100%
                margin-bottoom 1.4rem
                img {
                    width 49px
                    height auto
                }
            }
            +layout-sm() {
                top 30rem
                left 0
                right 0
                max-width 550px
                margin 0 auto
                .guide__arrows {
                    left 1rem
                    bottom 100%
                    margin-bottom 0.5rem
                    img {
                        width auto
                        height 50px
                    }
                }
            }
            +layout-xs() {
                left 2rem
                top 24.8rem
                width 28rem
            }
        }
        &--index-2 {
            top 33rem
            left 30%
            width 40%
            .guide__arrows {
                position absolute
                bottom 100%
                left 40%
                margin-bottom 1rem
                img {
                    width 168px
                    height auto
                }
            }
            +layout-sm() {
                width 25rem
                left 6rem
                top 23.7rem
                .guide__arrows {
                    left 70%
                    top 100%
                    margin-top 5rem
                    img {
                        width 22px
                        height auto
                    }
                }
            }
            +layout-xs() {
                left 2rem
                top 14rem
                .guide__arrows {
                    left 70%
                    top 100%
                    margin-top 5rem
                    img {
                        width 22px
                        height auto
                    }
                }
            }
        }
        &--index-3 {
            top 8rem
            left 14%
            width 34%
            .guide__arrows {
                position absolute
                top 2rem
                left 100%
                margin-left 7rem
                img {
                    width 83px
                    height auto
                }
            }
            +layout-sm() {
                width 28rem
                left 6rem
                top 3rem
                .guide__arrows {
                    left 45%
                    top 100%
                    margin-left 0
                    margin-top 0
                    img {
                        width auto
                        height 50px
                    }
                }
                .guide__footer {
                    position absolute
                    top 37rem
                }
            }
            +layout-xs() {
                left 2rem
                top 6rem
            }
        }
        &--index-4 {
            top 28rem
            left 30%
            width 34%
            .guide__arrows {
                position absolute
                top 6rem
                left 100%
                margin-left 2rem
                img {
                    width 84px
                    height auto
                }
            }
            +layout-sm() {
                width 28rem
                left 6rem
                top 28rem
                .guide__arrows {
                    left 60%
                    top 100%
                    margin-left 0
                    margin-top 0
                    img {
                        width 43px
                        height auto
                    }
                }
            }
            +layout-xs() {
                left 2rem
            }
        }
        &--index-5 {
            top 24.5rem
            left 45.8%
            width 50%

            +layout-sm() {
                left 0
                right 0
                top 25rem
                width 100%
                max-width 550px
                margin 0 auto
                .guide__content {
                    padding 1.5rem 2rem 0
                }
                .guide__footer {
                    padding 0 2rem
                }
            }
            +layout-xs() {
                top 26rem
                max-width 350px
                .guide__content {
                    padding 0.5rem 2rem 0
                }
                .guide__footer {
                    padding 0 2rem
                }
            }

            .guide__arrows {
                position absolute
                top 0
                left 0
                +layout-sm() {
                    bottom 100%
                    top auto
                    right 0
                    width 100%
                    margin 0 auto
                }
                img:nth-child(1) {
                    width 17px
                    height auto
                    position absolute
                    bottom 100%
                    right 100%
                    margin-bottom 1.4rem
                    +layout-sm() {
                        width auto
                        height 42px
                        bottom 0
                        right auto
                        left 16%
                        margin-bottom 0
                    }
                    +layout-xs() {
                        width auto
                        height 42px
                        bottom 0
                        right auto
                        left 15%
                        margin-bottom 0
                    }
                }
                img:nth-child(2) {
                    width 176px
                    height auto
                    position absolute
                    bottom 100%
                    right 100%
                    margin-right 2rem
                    margin-bottom -2rem
                    +layout-sm() {
                        width auto
                        height 31px
                        bottom 0
                        left 44.2%
                        right auto
                        margin-right 0
                        margin-bottom 0
                    }
                    +layout-xs() {
                        width auto
                        height 31px
                        bottom 0
                        left 45%
                        right auto
                        margin-right 0
                        margin-bottom 0
                    }
                }
                img:nth-child(3) {
                    width 115px
                    height auto
                    position absolute
                    top 0
                    right 100%
                    margin-right 2rem
                    margin-top 3rem
                    +layout-sm() {
                        width auto
                        height 92px
                        bottom 0
                        top auto
                        left 59%
                        right auto
                        margin-right 0
                        margin-top 0
                    }
                    +layout-xs() {
                        width auto
                        height 92px
                        bottom 0
                        top auto
                        left 62%
                        right auto
                        margin-right 0
                        margin-top 0
                    }
                }
            }
        }
        &--index-6 {
            top 7rem
            left 6rem
            width 35rem
            +layout-sm() {
                width 28rem
                left 6rem
                top 5.6rem
            }
            +layout-xs() {
                left 2rem
            }
        }
    }

    .guide-img-desktop {
        +layout-sm() {
            display none
        }
    }
    .guide-img-mobile {
        display none
        +layout-sm() {
            display block
        }
    }

    .fade-enter-active,
    .fade-leave-active {
        transition opacity 0.3s ease
    }

    .fade-enter,
    .fade-leave-to {
        opacity 0
    }

    .fade2-enter-active,
    .fade2-leave-active {
        transition opacity 0.6s ease, transform 0.6s ease
    }

    .fade2-enter,
    .fade2-leave-to {
        opacity 0
        transform translate(0, -2rem)
    }
</style>
